import React from "react";

const Chip = ({ name, onRemove }) => (
    <span className="inline-flex items-center gap-2 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
        <span className="truncate max-w-[10rem]">{name}</span>
        {onRemove && (
            <button
                onClick={onRemove}
                className="text-blue-700 text-xs rounded-full p-[2px] hover:bg-blue-200"
                aria-label={`Remove ${name}`}
            >
                ✕
            </button>
        )}
    </span>
);

export default Chip;
